import { ApartmentInfo, DefaultApartmentInfo, RomanianApartmentInfo, } from "../ordering";
export const APARTMENT_INFO_KEY = "client_apartment_info";
export class ApartmentInfoStorageManager {
    constructor(country) {
        this.country = country;
    }
    store(apartmentInfo) {
        const apartmentInfoData = apartmentInfo.type === "Default"
            ? {
                type: "Default",
                aptNumber: apartmentInfo.data.aptNumber,
                floor: apartmentInfo.data.floor,
            }
            : {
                type: "Romanian",
                sector: apartmentInfo.data.sector,
                houseOrBlock: apartmentInfo.data.houseOrBlock,
                block: apartmentInfo.data.block,
                staircase: apartmentInfo.data.staircase,
                floor: apartmentInfo.data.floor,
                aptNumber: apartmentInfo.data.aptNumber,
                interphone: apartmentInfo.data.interphone,
                additionalInfo: apartmentInfo.data.additionalInfo,
            };
        const apartmentInfoDataStrign = JSON.stringify(apartmentInfoData);
        localStorage.setItem(APARTMENT_INFO_KEY, apartmentInfoDataStrign);
    }
    restore() {
        const apartmentInfoDataString = localStorage.getItem(APARTMENT_INFO_KEY);
        if (apartmentInfoDataString === null) {
            return ApartmentInfo.empty(this.country);
        }
        const apartmentInfoData = JSON.parse(apartmentInfoDataString);
        if (this.country === "RO" && apartmentInfoData.type === "Romanian") {
            const romanianApartmentInfo = new RomanianApartmentInfo();
            romanianApartmentInfo.setData({
                sector: apartmentInfoData.sector,
                houseOrBlock: apartmentInfoData.houseOrBlock,
                block: apartmentInfoData.block,
                staircase: apartmentInfoData.staircase,
                floor: apartmentInfoData.floor,
                aptNumber: apartmentInfoData.aptNumber,
                interphone: apartmentInfoData.interphone,
                additionalInfo: apartmentInfoData.additionalInfo,
            });
            return romanianApartmentInfo;
        }
        else if (this.country !== "RO") {
            const defaultApartmentInfo = new DefaultApartmentInfo();
            defaultApartmentInfo.setData({
                aptNumber: apartmentInfoData.aptNumber,
                floor: apartmentInfoData.floor,
            });
            return defaultApartmentInfo;
        }
        return ApartmentInfo.empty(this.country);
    }
}
